import { render, staticRenderFns } from "./VehicleAssignModal.vue?vue&type=template&id=311908ec"
import script from "./VehicleAssignModal.vue?vue&type=script&lang=js"
export * from "./VehicleAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports